import React from 'react';
import {
  BranchesOutlined,
  CopyOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import releaseConfig from '../../../config.json';
import './DevelopmentTool.scss';
import PRZSelect from '../Common/UI/PRZSelect';

const options = [
  {
    value: 'https://listener.procuzy.com',
    label: 'Prod',
  },
  {
    value: 'https://test-dev.procuzy.com',
    label: 'dev',
  },
  {
    value: 'https://utkarsh.procuzy.com',
    label: 'Utkarsh',
  },
  {
    value: 'https://himanshu-mac.procuzy.com',
    label: 'Himanshu',
  },
  {
    value: 'https://uat.listener.procuzy.com',
    label: 'UAT',
  },
  {
    value: 'https://test-dev.procuzy.com',
    label: 'AWS Dev',
  },
  {
    value: 'https://udit-dev.procuzy.com',
    label: 'Udit',
  },
  {
    value: 'https://sainadh-mac.procuzy.com',
    label: 'Sainadh',
  },
  {
    value: 'https://sagar-local.procuzy.com',
    label: 'Sagar',
  },
  {
    value: 'https://sumanth-laptop.procuzy.com',
    label: 'Sumanth',
  },
  {
    value: 'http://localhost:3000',
    label: 'Local',
  },
  {
    value: 'https://satyajeet-local.procuzy.com',
    label: 'Satyajeet',
  },
  {
    value: 'https://akshat-local.procuzy.com',
    label: 'Akshat',
  },
  {
    value: 'http://ashish-local.procuzy.com',
    label: 'Ashish',
  },
  {
    value: 'https://harshit-local.procuzy.com',
    label: 'Harshit',
  },
  {
    value: '',
    label: 'Reset',
  },
];

const offtimeSelectorOptions = [
  {
    value: 'true',
    label: 'Reset Settings',
  },
  {
    value: 'false',
    label: 'Remove Offtime',
  },
];

const handleChange = (value) => {
  localStorage.setItem('override_url', value);
  window.location.reload(1);
};

const offtimeSelectorHandleChange = (value) => {
  localStorage.setItem('offtime', value);
  window.location.reload(1);
};

const onClickCopyButton = () => {
  navigator.clipboard.writeText(
    localStorage.getItem('h3m-procuzy-access-token')
  );
};

const DevelopmentTool = () => (
  <React.Fragment>
    {(releaseConfig.environment === 'dev' ||
      localStorage.getItem('debug_mode') === 'true') && (
      <div className="development-tool-main">
        <PRZSelect
          size="small"
          suffixIcon={<ToolOutlined style={{ color: 'white' }} />}
          dropdownMatchSelectWidth={false}
          bordered={false}
          options={offtimeSelectorOptions}
          onChange={offtimeSelectorHandleChange}
          style={{ width: '30px', marginRight: '2px', marginLeft: '0px' }}
          placeholder=""
        />
        <PRZSelect
          size="small"
          suffixIcon={<BranchesOutlined style={{ color: 'white' }} />}
          dropdownMatchSelectWidth={false}
          bordered={false}
          options={options}
          onChange={handleChange}
          style={{ width: '30px', marginRight: '2px' }}
          placeholder=""
        />
        <CopyOutlined onClick={onClickCopyButton} />
      </div>
    )}
  </React.Fragment>
);
export default DevelopmentTool;
